﻿import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { QuestionaireModule, MedicalAidInsuranceModule } from '@app/shared/models_elevate/models';
import { ProductFactory } from '@app/shared/FactoryResources/ProductFactory/IIncompleteProduct';
import { AppConsts } from '@shared/AppConsts';
import * as moment from 'moment';
import { CreateExtQuoteModule, ExternalQuoteModule } from '../../../../../shared/models/interfaces/elevate-data-models';
import { PersonEducation } from '../../../../../shared/AppEnums';
import { finalize } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class MyNeedsCalculatorService {

    private _questionaireUrl = '/assets/data/questionaire.json';
    private _occupationUrl = '/assets/data/occupation.json';
    private _insuranceUrl = '/assets/data/InsuranceMedicalAidSchemes.json';
    unitRate: number;

    vm = {

    };

    //error on unitrate was assigned this.unitRate
    public cachedData = {
        unitRate: 0,
        // tslint:disable-next-line: no-use-before-declare
        finalData: new FinalData(),
        // tslint:disable-next-line: no-use-before-declare
        calculatedData: new CalculatedData(),
        // tslint:disable-next-line: no-use-before-declare
        answerSections: new AnsweredSections()
    };
    productConfig: any;
    defaultProduct: any;
    extQuoteResponses: any[] = [];
    constructor(
        private http: HttpClient,
        private injector: Injector
    ) { this.getProductConfig(); }

    async getUnitRateAsync() {
        let productUID = '8a17c46f-cbc5-4352-8930-aebae605cfe9';
        let productFactory = await new ProductFactory(this.injector)
            .withMetadataAsync(abp.setting.values[AppConsts.KeyVaultSecrets.ActiveGenerationName]);

        let self = this;

        let benefitPatternSetPromise = productFactory.forProduct(productUID)
            .extractBenefitPatternSetAsync();

        let premiumPatternSetPromise = productFactory.forProduct(productUID)
            .extractPremiumPatternSetAsync();

        await Promise.all([benefitPatternSetPromise, premiumPatternSetPromise]);

        // await productFactory
        //     .setRateTableAsync(productFactory.getBenefitPatternSet(), productFactory.getPremiumPatternSet(), );

        let product = productFactory.build();

        let unitRate = product.RateTable.reduce(
            (max, item) => (item.BaseRate > max ? item.BaseRate : max),
            product.RateTable[0].UnitRate
        );

        self.cachedData.unitRate = unitRate;
    }

    public getQuestionaireData(): Observable<QuestionaireModule.IQuestionaire[]> {
        return this.http.get<QuestionaireModule.IQuestionaire[]>(this._questionaireUrl);
    }

    public getOccupationList(): Observable<Object> {
        return this.http.get(this._occupationUrl);
    }

    public getMedicalAidSchemesList(): Observable<MedicalAidInsuranceModule.IScheme[]> {
        return this.http.get<MedicalAidInsuranceModule.IScheme[]>(this._insuranceUrl);
    }


    private getFamilyStepper() {
        if (this.cachedData) {
            if (this.cachedData.answerSections) {
                return this.cachedData.answerSections.familySectionAnswers;
            }
        }
    }

    private getEarningStepper() {
        if (this.cachedData) {
            if (this.cachedData.answerSections) {
                return this.cachedData.answerSections.earningSectionAnswers;
            }
        }
    }

    getAge() {
        try {
            if (this.getFamilyStepper()) {
                let getFamilyStepper = this.getFamilyStepper();

                let age = getFamilyStepper.familyAnswers.value.find(x => x.label === 'I was born on');
                if (age) {
                    return moment(age.value).format('yyyy-MM-DD').getAgeFromDate();
                }
            }
        } catch (e) {
            return 18;
        }
    }


    getGender() {
        try {
            if (this.getFamilyStepper()) {
                let getFamilyStepper = this.getFamilyStepper();

                let gender = getFamilyStepper.familyAnswers.value[0].genderSection;
                if (gender) {
                    return (gender.value as string).maleStringToInt();
                }
            }
        } catch (e) {
            return 0;
        }
    }

    getGrossIncome() {

        try {
            if (this.getEarningStepper) {
                let getEarningStepper = this.getEarningStepper().find(x => x.question === 'How much do you earn?');
                if (getEarningStepper) {
                    return getEarningStepper.answers[0].value[0].value;
                }
            }
        } catch (e) {
            return 10000;
        }
    }

    gethouseHoldIncome() {
        return undefined;
    }

    getOccupations() {

        if (this.getEarningStepper) {
            let getEarningStepper = this.getEarningStepper().find(x => x.question === 'What is your occupation?');
            if (getEarningStepper) {
                return getEarningStepper.answers[0].value[0].value;
            }
        }

        return null;
    }

    getEducation() {

        let dropdownItems = [
            {
                name: AppConsts.QuoteEducation.Nomatric,
                value: PersonEducation.NoMatric
            },
            {
                name: AppConsts.QuoteEducation.Matric,
                value: PersonEducation.Matric
            }, {
                name: AppConsts.QuoteEducation.Diplomalessthan,
                value: PersonEducation.DiplomaLessThanFourYears
            }, {
                name: AppConsts.QuoteEducation.Diplomaequalorgreater,
                value: PersonEducation.DiplomaFourYearsOrMoreThan
            }, {
                name: AppConsts.QuoteEducation.University,
                value: PersonEducation.ThreeYearsUniversityUnderGraduateDegree
            }, {
                name: AppConsts.QuoteEducation.University4Years,
                value: PersonEducation.FourYearsUniversityUnderGraduateDegree
            }, {
                name: AppConsts.QuoteEducation.Postgraduate,
                value: PersonEducation.PostGraduateStudy
            }
        ];

        try {
            if (this.getEarningStepper) {
                let getEarningStepper = this.getEarningStepper().find(x => x.question === 'What is your education level?');
                if (getEarningStepper) {
                    return dropdownItems.find(x => x.name === getEarningStepper.answers[0].value[0].value).value;
                }
            }
        } catch (e) {
            return 0;
        }


        return undefined;
    }

    getSmoker() {
        return 0;
    }

    getSumAssured(productName) {

        if (productName === AppConsts.configProducts.Disability) {
            return this.cachedData.finalData.DisabilityLumpsumAmount;
        }

        if (productName === AppConsts.configProducts.Life) {
            return this.cachedData.finalData.lifeInsuranceLumpsumAmount;
        }

        if (productName === AppConsts.configProducts.SevereIllness) {
            return this.cachedData.finalData.SevereIllnessLumpsumAmount;
        }

        return 100000;
    }

    getProductConfig() {
        let url = abp.setting.values[AppConsts.KeyVaultSecrets.AppConfigAngularProductConfigUrl];

        this.http.get<any>(url).subscribe(res => {
            this.productConfig = res;
            if (res) {
                this.defaultProduct = res.find(x => x.IsDefault);
            }
        });

    }


    createExtQuoteForAllProduct(callback) {
        this.extQuoteResponses = [];
        let observerArray = [];
        this.productConfig.forEach(element => {
            observerArray.push(this.createExtQuote(element));
        });

        forkJoin(observerArray)
            .subscribe(res => {
                this.extQuoteResponses = this.extQuoteResponses.concat(res);
                callback();
                abp.ui.clearBusy();
            }, (err) => {
            });


    }


    createExtQuote(defaultProduct): Observable<any> {
        if (!this.productConfig) {
            return;
        }


        if (!defaultProduct) {
            return;
        }

        let extQuoteeBody: CreateExtQuoteModule.CreateExtQuote = {
            productFriendlyName: defaultProduct.FriendlyName,
            productUid: defaultProduct.UID,
            ratingFactor: {
                age: this.getAge(),
                education: this.getEducation(),
                gender: this.getGender(),
                income: this.getGrossIncome(),
                smokingStatus: this.getSmoker()
            },
            sumAssuredAmount: this.getSumAssured(defaultProduct.FriendlyName),
            vendorId: abp.setting.values[AppConsts.KeyVaultSecrets.MicroServicesExtQuoteVendorId],
            additionalInformation: {
                hivStatus: '',
                majorConditions: '',
                prescribedMedication: '',
                treatmentLastFourMonths: '',
                upcomingTreatment: ''
            }
        };

        abp.ui.setBusy();

        let url = abp.setting.values[AppConsts.KeyVaultSecrets.MicroServicesExtQuote] + AppConsts.Endpoints.CreateExtQuoteDetails;
        let headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': abp.setting.values[AppConsts.KeyVaultSecrets.MicroServicesExtQuoteOcpApimSubscriptionKey],
            'Content-Type': 'application/json'
        });
        return this.http.post<ExternalQuoteModule.ExternalQuote>(url, extQuoteeBody, { headers: headers });
    }

    getPremiumByProduct() {

    }

    sendQuote(body) {
        abp.ui.setBusy();
        let url = abp.setting.values[AppConsts.KeyVaultSecrets.PortalSettingsauthority] + AppConsts.Endpoints.sendQuote;
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });
        return this.http.post(url, body, { headers: headers }).pipe(finalize(() => {
            abp.ui.clearBusy();
        })).subscribe(res => {
            abp.notify.success('Sent');
        });
    }


}

class CalculatedData {
    childrenLumpSumExpense: number;
    childrenMonthlyExpense: number;
    totalMonthlyDebtAmount: number;
    totalDebtOutstandingAmount: number;
    totalInsuranceExpenseAmount: number;
    monthlyHouseRental: number;
    annualIncomeAmount: number;
}

class FinalData {
    lifeInsuranceLumpsumAmount: number;
    SevereIllnessLumpsumAmount: number;
    DisabilityLumpsumAmount: number;
}

class FamilyStepperData {
    familyAnswers: QuestionaireModule.IAnswer;
    chilrenAgeList: any[];
}

class HomeStepperData {
    selectedOption: QuestionaireModule.IAnswer;
    debtSelectedOptions: QuestionaireModule.IDebtOptions[];
}

class InsuranceStepperData {
    employmentInsuranceSchemes: QuestionaireModule.IInsuranceOptions[];
    purchasedInsuranceSchemes: QuestionaireModule.IInsuranceOptions[];
}

class AnsweredSections {
    familySectionAnswers = new FamilyStepperData();
    earningSectionAnswers: QuestionaireModule.IQuestionAnswerSection[];
    homeSectionAnswers = new HomeStepperData();
    insuranceSectionAnswers = new InsuranceStepperData();
    expenseSectionAnswers: QuestionaireModule.IQuestionAnswerSection;
    tempEmploymentInsuranceList = new Array();
    tempPurchasedInsuranceList = new Array();
    selectedPurchasedInsuranceList = new Array();
    selectedEmploymentInsuranceList = new Array();
}






